import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';

import { CustomAlert } from '../CustomComponents/CustomComponents';
import { LinkIcon } from '../LinkIcon/LinkIcon';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';

interface PermissionGainAccessItemProps {
    requestable: boolean;
    reason: string;
    subtitle: string;
    readOnly: boolean;
    link?: string | null;
    translations: Record<string, string>;
}

export const PermissionGainAccessItem: React.FC<PermissionGainAccessItemProps> = ({
    requestable,
    reason,
    subtitle,
    readOnly,
    link,
    translations,
}) => {
    const alert = (
        <CustomAlert icon={false} severity="error">
            <Grid container alignItems="center">
                <Grid
                    item
                    xs={11}
                    style={{
                        flexFlow: 'column',
                    }}
                >
                    <Typography variant="body1" fontWeight={600} color="textPrimary">
                        {reason} {!readOnly && link && <LinkIcon link={link} />}
                    </Typography>
                    {((!readOnly && link) || requestable) && (
                        <Typography variant="body2" color="textSecondary">
                            {subtitle}
                        </Typography>
                    )}
                </Grid>
                {link && !readOnly && (
                    <Grid item xs={1} style={{ justifyContent: 'flex-end' }}>
                        <Typography color="textPrimary">
                            <ChevronRightIcon />
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </CustomAlert>
    );

    return readOnly ? (
        alert
    ) : (
        <LinkWrapper to={link} translations={translations}>
            {alert}
        </LinkWrapper>
    );
};
